import { render, staticRenderFns } from "./modalWrapper.vue?vue&type=template&id=5af8bc94&scoped=true&lang=html&"
import script from "./modalWrapper.vue?vue&type=script&lang=js&"
export * from "./modalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./modalWrapper.vue?vue&type=style&index=0&id=5af8bc94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af8bc94",
  null
  
)

export default component.exports